import React from "react";
import { CheckIcon } from "lucide-react";
import { volumes } from "../data/volumes";
import { product } from "../data/product";
import { CtaButton } from "./ui/CtaButton";
import { ImageSlot } from "./ui/ImageSlot";
export function Collections() {
  return <section className="bg-cream px-4 pb-14 sm:px-6 sm:pb-20" aria-label="I 6 volumi di ricette" data-id="element-56" data-mp="2aygwcvclurb0">
      <div className="mx-auto max-w-6xl space-y-14 lg:space-y-20" data-id="element-57" data-mp="2fsuwtc64jomj">
        {volumes.map((v, i) => <article key={v.number} className="grid gap-7 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-58" data-mp="2ksh7peyhcss6" data-mpi={i}>
            <div className={i % 2 === 1 ? "lg:order-2" : ""} data-id="element-59" data-mp="2pr0xxrk3wqqc">
              <ImageSlot src={v.image} alt={`Volume ${v.number}: ${v.title}`} placeholderLabel={`Foto del volume ${v.number}`} className="aspect-square w-full rounded-[28px]" data-id="element-60" data-mp="2uosnwg16y2rw" />
            </div>
            <div data-id="element-61" data-mp="14b3a391x1i3t">
              <h3 className="font-serif text-[28px] font-semibold leading-[1.15] text-wine sm:text-[36px]" data-id="element-62" data-mp="14cmpkxfqzp4j">
                {v.title}
                <span className="block text-rose" data-id="element-63" data-mp="1bq1620hki3ie">
                  Volume {v.number}
                  {v.count !== undefined && ` · ${v.count} ricette`}
                </span>
              </h3>
              <p className="mt-4 text-[16px] leading-relaxed text-ink sm:text-[17px]" data-id="element-64" data-mp="11w0ylrytcm6i">{v.description}</p>
              {v.items.length > 0 && <ul className="mt-5" data-id="element-65" data-mp="1un2i259jh3vu">
                  {v.items.map(item => <li key={item} className="flex items-center gap-3 border-b border-line py-3 last:border-0" data-id="element-66" data-mp="1pnzcmjpncvnc">
                      <CheckIcon className="h-[18px] w-[18px] shrink-0 text-rose" strokeWidth={1.5} aria-hidden="true" data-id="element-67" data-mp="1kntr7l9z05dp" />
                      <span className="text-[15px] leading-snug text-ink" data-id="element-68" data-mp="1foqklwecdr3m">{item}</span>
                    </li>)}
                </ul>}
            </div>
          </article>)}
        <div className="flex justify-center" data-id="element-69" data-mp="48tljfcshqso">
          <CtaButton data-id="element-70" data-mp="2sglcfxmcvxpx">Ottieni il bundle di {product.recipesText} ricette</CtaButton>
        </div>
      </div>
    </section>;
}